import { Navigate, Route, Routes } from "react-router-dom";
import { DesignV2Scope } from "../design-v2";
import ChooseWorkoutScreen from "../features/workoutLog/screens/ChooseWorkoutScreen";
import ExecutionScreen from "../features/workoutLog/screens/ExecutionScreen";
import StartWorkoutScreen from "../features/workoutLog/screens/StartWorkoutScreen";
import TrainHub, { FLAG_ENABLED } from "../features/workoutLog/screens/TrainHub";
import WorkoutDetailsScreen from "../features/workoutLog/screens/WorkoutDetailsScreen";
import useTrainIdentity from "../features/workoutLog/recovery/trainIdentity";
import "../features/workoutLog/workoutLog.css";

export default function Train() {
  // Start, Choose Workout and Workout Details are server-backed: a local
  // recovery shell returns to the Hub instead (§9.8 "Local-mode exits").
  const localMode = useTrainIdentity()?.mode === "local";
  return (
    <DesignV2Scope className="lz-workout-log">
      <Routes>
        <Route index element={<TrainHub />} />
        <Route path="start" element={FLAG_ENABLED && !localMode ? <StartWorkoutScreen /> : <Navigate to="/train" replace />} />
        <Route path="session/:executionId" element={<ExecutionScreen />} />
        <Route path="session/:executionId/review" element={<ExecutionScreen review />} />
        <Route path="log/:executionId" element={FLAG_ENABLED && !localMode ? <WorkoutDetailsScreen /> : <Navigate to="/train" replace />} />
        <Route path="choose" element={localMode ? <Navigate to="/train" replace /> : <ChooseWorkoutScreen enabled={FLAG_ENABLED} />} />
        <Route path="*" element={<Navigate to="/train" replace />} />
      </Routes>
    </DesignV2Scope>
  );
}
